export const AUTH_URL = import.meta.env.VITE_AUTH_URL || 'https://auth.copte.fr'
export const AUTH_API_URL = `${AUTH_URL}/api/auth`
